import { ChangePasswordImport } from './Import'
const { ChangePasswordForm, Modal, toggleChangePasswordModal, useDispatch, useSelector, useTranslation } = ChangePasswordImport

export default function ChangePassword() {

    const { t } = useTranslation()

    const dispatch = useDispatch()

    const show = useSelector((state) => state.global.changePasswordModal)

    const handleClose = () => dispatch(toggleChangePasswordModal())

    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                header={t('profile.change_password')}
                FormPage={ChangePasswordForm}
            />
        </>
    )
}